import TalentManagementLive from "./live";

export default TalentManagementLive;

/* Legacy static design reference retained below during the live workflow migration.
import { useMemo, useState } from "react";
import { FiArrowRight, FiBriefcase, FiCheckCircle, FiClock, FiMapPin, FiShield, FiTrendingUp, FiUsers } from "react-icons/fi";

const clientData = [
  { id: 1, name: "Apex Manufacturing", status: "Active", site: "Lagos", manager: "Ada Okafor", department: "Operations", placements: 28, vacancies: 5, renewal: "12 days" },
  { id: 2, name: "BlueNest Retail", status: "Scaling", site: "Abuja", manager: "Tunde Adebayo", department: "Retail", placements: 18, vacancies: 2, renewal: "28 days" },
  { id: 3, name: "Boreal Logistics", status: "Watch", site: "Port Harcourt", manager: "Mariam Yusuf", department: "Logistics", placements: 14, vacancies: 6, renewal: "4 days" },
  { id: 4, name: "Cedar Pharma", status: "Active", site: "Ibadan", manager: "Grace Etim", department: "Support", placements: 22, vacancies: 3, renewal: "21 days" },
];

const staffingData = [
  { name: "Daniel Okoye", role: "Operations Supervisor", client: "Apex Manufacturing", location: "Lagos", status: "Onsite", contract: "Active" },
  { name: "Iniabasi Udo", role: "Inventory Analyst", client: "BlueNest Retail", location: "Abuja", status: "Remote", contract: "Review" },
  { name: "Nneka Eze", role: "Dispatch Coordinator", client: "Boreal Logistics", location: "Port Harcourt", status: "Onsite", contract: "Active" },
  { name: "Bello Sanni", role: "Support Associate", client: "Cedar Pharma", location: "Ibadan", status: "Hybrid", contract: "Renewal" },
];

const vacancyData = [
  { title: "Operations Supervisor", client: "Apex Manufacturing", team: "Operations", stage: "Client review", applicants: 38, urgency: "High" },
  { title: "Retail Associate", client: "BlueNest Retail", team: "Retail", stage: "Interview", applicants: 24, urgency: "Medium" },
  { title: "Dispatch Coordinator", client: "Boreal Logistics", team: "Logistics", stage: "Offer", applicants: 17, urgency: "High" },
  { title: "Customer Support Officer", client: "Cedar Pharma", team: "Support", stage: "Screening", applicants: 51, urgency: "Medium" },
];

const onboardingChecklist = [
  { label: "Biodata capture", done: true },
  { label: "Document verification", done: true },
  { label: "Guarantor review", done: false },
  { label: "Client onboarding sign-off", done: false },
  { label: "Deployment confirmation", done: false },
];

const valueTone = {
  Active: "bg-emerald-50 text-emerald-700",
  Scaling: "bg-sky-50 text-sky-700",
  Watch: "bg-amber-50 text-amber-700",
  Review: "bg-violet-50 text-violet-700",
  Renewal: "bg-orange-50 text-orange-700",
  Onsite: "bg-slate-100 text-slate-700",
  Remote: "bg-indigo-50 text-indigo-700",
  Hybrid: "bg-cyan-50 text-cyan-700",
  "Client review": "bg-sky-50 text-sky-700",
  Interview: "bg-violet-50 text-violet-700",
  Offer: "bg-emerald-50 text-emerald-700",
  Screening: "bg-amber-50 text-amber-700",
};

function TalentManagement() {
  const [tab, setTab] = useState("overview");

  const stats = useMemo(
    () => [
      { label: "Active clients", value: "24", icon: FiUsers },
      { label: "Placed staff", value: "1,482", icon: FiBriefcase },
      { label: "Open vacancies", value: "42", icon: FiClock },
      { label: "Onboarding flow", value: "83%", icon: FiTrendingUp },
    ],
    [],
  );

  return (
    <main className="min-h-screen bg-[#f8fafc] p-4 font-Outfit sm:p-6">
      <div className="mx-auto max-w-7xl">
        <header className="flex flex-col justify-between gap-4 lg:flex-row lg:items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#1234CD]">Talent management</p>
            <h1 className="mt-2 text-2xl font-black text-[#071C50] sm:text-3xl">HR outsourcing and workforce pipeline</h1>
            <p className="mt-2 max-w-2xl text-sm text-slate-500">
              Manage client accounts, track recruitment flow, monitor deployment, and keep onboarding and guarantor reviews moving without losing visibility.
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <button className="rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-bold text-[#071C50]">New workforce request</button>
            <button className="rounded-xl bg-[#1234CD] px-4 py-2.5 text-sm font-bold text-white">+ Add client</button>
          </div>
        </header>

        <section className="mt-6 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
          {stats.map(({ label, value, icon: Icon }) => (
            <article key={label} className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
              <div className="flex items-center justify-between">
                <span className="rounded-xl bg-indigo-50 p-2 text-[#1234CD]">
                  <Icon className="h-4 w-4" />
                </span>
                <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-400">Live</span>
              </div>
              <p className="mt-4 text-2xl font-black text-[#071C50]">{value}</p>
              <p className="mt-1 text-xs text-slate-500">{label}</p>
            </article>
          ))}
        </section>

        <nav className="mt-6 flex flex-wrap gap-2 rounded-2xl bg-slate-200/70 p-1.5">
          {[
            ["overview", "Overview"],
            ["clients", "Clients"],
            ["workforce", "Workforce"],
            ["recruitment", "Recruitment"],
            ["onboarding", "Onboarding"],
          ].map(([key, label]) => (
            <button
              key={key}
              type="button"
              onClick={() => setTab(key)}
              className={`flex-1 rounded-xl px-4 py-2.5 text-sm font-bold transition ${
                tab === key ? "bg-white text-[#1234CD] shadow-sm" : "text-slate-500"
              }`}
            >
              {label}
            </button>
          ))}
        </nav>

        {tab === "overview" && (
          <section className="mt-6 grid gap-5 xl:grid-cols-[1.4fr_0.9fr]">
            <div className="space-y-5">
              <article className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="flex items-center justify-between gap-3">
                  <div>
                    <h2 className="text-lg font-bold text-[#071C50]">Client-to-deployment cycle</h2>
                    <p className="mt-1 text-xs text-slate-500">From workforce request to staff deployment and review.</p>
                  </div>
                  <span className="rounded-full bg-indigo-50 px-2.5 py-1 text-[10px] font-bold text-[#1234CD]">End-to-end view</span>
                </div>
                <div className="mt-5 grid gap-3 md:grid-cols-5">
                  {[
                    ["Client request", "Acquire client"],
                    ["Vacancy", "Create & publish"],
                    ["Recruit", "Screen & shortlist"],
                    ["Onboard", "Verify & approve"],
                    ["Deploy", "Assign & manage"],
                  ].map(([name, step], index) => (
                    <div key={name} className="rounded-xl border border-slate-200 bg-slate-50 p-3">
                      <div className="mb-2 flex items-center justify-between">
                        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#1234CD] text-[10px] font-black text-white">{index + 1}</span>
                        {index < 4 && <FiArrowRight className="text-slate-300" />}
                      </div>
                      <p className="text-sm font-bold text-[#071C50]">{name}</p>
                      <p className="mt-1 text-[11px] text-slate-500">{step}</p>
                    </div>
                  ))}
                </div>
              </article>

              <article className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <h2 className="text-lg font-bold text-[#071C50]">Active client portfolio</h2>
                <div className="mt-4 space-y-3">
                  {clientData.map((client) => (
                    <div key={client.id} className="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-3 sm:flex-row sm:items-center sm:justify-between">
                      <div>
                        <div className="flex flex-wrap items-center gap-2">
                          <h3 className="text-sm font-bold text-[#071C50]">{client.name}</h3>
                          <span className={`rounded-full px-2 py-1 text-[10px] font-semibold ${valueTone[client.status] || "bg-slate-100 text-slate-700"}`}>
                            {client.status}
                          </span>
                        </div>
                        <div className="mt-2 flex flex-wrap items-center gap-3 text-[11px] text-slate-500">
                          <span className="inline-flex items-center gap-1"><FiMapPin className="h-3.5 w-3.5" />{client.site}</span>
                          <span>{client.manager}</span>
                          <span>{client.department}</span>
                        </div>
                      </div>
                      <div className="flex flex-wrap gap-2 text-[11px] text-slate-600">
                        <span className="rounded-full bg-white px-2 py-1">{client.placements} placed</span>
                        <span className="rounded-full bg-white px-2 py-1">{client.vacancies} open vacancies</span>
                        <span className="rounded-full bg-white px-2 py-1">Renewal in {client.renewal}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </article>
            </div>

            <aside className="space-y-5">
              <article className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <h2 className="text-lg font-bold text-[#071C50]">Priorities this week</h2>
                <ul className="mt-4 space-y-3">
                  {[
                    "Review 6 pending guarantor verifications",
                    "Approve 3 client candidate submissions",
                    "Confirm 2 deployment starts this week",
                    "Close 5 contractor renewals",
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm text-slate-600">
                      <FiCheckCircle className="mt-0.5 text-emerald-500" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </article>

              <article className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <h2 className="text-lg font-bold text-[#071C50]">Compliance snapshot</h2>
                <div className="mt-4 space-y-4">
                  {[
                    ["Document verification", 82],
                    ["Guarantor approvals", 67],
                    ["Deployment readiness", 91],
                  ].map(([label, value]) => (
                    <div key={label}>
                      <div className="mb-1 flex items-center justify-between text-[11px] text-slate-500">
                        <span>{label}</span>
                        <span>{value}%</span>
                      </div>
                      <div className="h-2.5 rounded-full bg-slate-100">
                        <div className="h-2.5 rounded-full bg-[#1234CD]" style={{ width: `${value}%` }} />
                      </div>
                    </div>
                  ))}
                </div>
              </article>
            </aside>
          </section>
        )}

        {tab === "clients" && (
          <section className="mt-6 grid gap-4 lg:grid-cols-2">
            {clientData.map((client) => (
              <article key={client.id} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h2 className="text-lg font-bold text-[#071C50]">{client.name}</h2>
                    <p className="mt-1 text-xs text-slate-500">{client.department} · {client.site}</p>
                  </div>
                  <span className={`rounded-full px-2 py-1 text-[10px] font-semibold ${valueTone[client.status] || "bg-slate-100 text-slate-700"}`}>
                    {client.status}
                  </span>
                </div>

                <div className="mt-4 grid gap-3 sm:grid-cols-2">
                  <div className="rounded-xl bg-slate-50 p-3">
                    <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400">Manager</p>
                    <p className="mt-2 text-sm font-bold text-[#071C50]">{client.manager}</p>
                  </div>
                  <div className="rounded-xl bg-slate-50 p-3">
                    <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400">Placements</p>
                    <p className="mt-2 text-sm font-bold text-[#071C50]">{client.placements}</p>
                  </div>
                  <div className="rounded-xl bg-slate-50 p-3">
                    <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400">Vacancies</p>
                    <p className="mt-2 text-sm font-bold text-[#071C50]">{client.vacancies}</p>
                  </div>
                  <div className="rounded-xl bg-slate-50 p-3">
                    <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400">Renewal</p>
                    <p className="mt-2 text-sm font-bold text-[#071C50]">{client.renewal}</p>
                  </div>
                </div>
              </article>
            ))}
          </section>
        )}

        {tab === "workforce" && (
          <section className="mt-6 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
            <div className="border-b border-slate-200 p-4">
              <h2 className="text-lg font-bold text-[#071C50]">Outsourced staff directory</h2>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-left text-sm">
                <thead className="bg-slate-50 text-[11px] uppercase tracking-[0.15em] text-slate-500">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Staff</th>
                    <th className="px-4 py-3 font-semibold">Client</th>
                    <th className="px-4 py-3 font-semibold">Location</th>
                    <th className="px-4 py-3 font-semibold">Mode</th>
                    <th className="px-4 py-3 font-semibold">Contract</th>
                  </tr>
                </thead>
                <tbody>
                  {staffingData.map((person) => (
                    <tr key={person.name} className="border-t border-slate-200">
                      <td className="px-4 py-3">
                        <div>
                          <p className="font-bold text-[#071C50]">{person.name}</p>
                          <p className="text-xs text-slate-500">{person.role}</p>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-slate-600">{person.client}</td>
                      <td className="px-4 py-3 text-slate-600">{person.location}</td>
                      <td className="px-4 py-3">
                        <span className={`rounded-full px-2 py-1 text-[10px] font-semibold ${valueTone[person.status] || "bg-slate-100 text-slate-700"}`}>
                          {person.status}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <span className={`rounded-full px-2 py-1 text-[10px] font-semibold ${valueTone[person.contract] || "bg-slate-100 text-slate-700"}`}>
                          {person.contract}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        )}

        {tab === "recruitment" && (
          <section className="mt-6 space-y-4">
            {vacancyData.map((job) => (
              <article key={job.title} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                  <div>
                    <div className="flex flex-wrap items-center gap-2">
                      <h2 className="text-lg font-bold text-[#071C50]">{job.title}</h2>
                      <span className={`rounded-full px-2 py-1 text-[10px] font-semibold ${valueTone[job.stage] || "bg-slate-100 text-slate-700"}`}>
                        {job.stage}
                      </span>
                    </div>
                    <p className="mt-1 text-xs text-slate-500">{job.client} · {job.team} · {job.applicants} applicants</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className={`rounded-full px-2.5 py-1 text-[10px] font-bold ${valueTone[job.urgency] || "bg-slate-100 text-slate-700"}`}>
                      {job.urgency} urgency
                    </span>
                    <button className="rounded-lg border border-slate-200 px-3 py-2 text-xs font-bold text-[#1234CD]">Review pipeline</button>
                  </div>
                </div>
              </article>
            ))}
          </section>
        )}

        {tab === "onboarding" && (
          <section className="mt-6 grid gap-5 lg:grid-cols-[1fr_0.8fr]">
            <article className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <h2 className="text-lg font-bold text-[#071C50]">Onboarding checklist</h2>
              <div className="mt-4 space-y-3">
                {onboardingChecklist.map((item) => (
                  <div key={item.label} className="flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50 p-3">
                    <div className="flex items-center gap-3">
                      <span className={`flex h-6 w-6 items-center justify-center rounded-full ${item.done ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-600"}`}>
                        {item.done ? <FiCheckCircle className="h-4 w-4" /> : <FiClock className="h-4 w-4" />}
                      </span>
                      <span className="text-sm font-medium text-[#071C50]">{item.label}</span>
                    </div>
                    <span className={`rounded-full px-2 py-1 text-[10px] font-semibold ${item.done ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
                      {item.done ? "Completed" : "Pending"}
                    </span>
                  </div>
                ))}
              </div>
            </article>

            <article className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <h2 className="text-lg font-bold text-[#071C50]">Next actions</h2>
              <ul className="mt-4 space-y-3 text-sm text-slate-600">
                <li className="flex items-start gap-2"><FiShield className="mt-0.5 text-[#1234CD]" /> Verify guarantor documents for 4 additional staff.</li>
                <li className="flex items-start gap-2"><FiTrendingUp className="mt-0.5 text-[#1234CD]" /> Finalise client review for 2 open vacancies.</li>
                <li className="flex items-start gap-2"><FiBriefcase className="mt-0.5 text-[#1234CD]" /> Activate deployment confirmations for approved hires.</li>
              </ul>
            </article>
          </section>
        )}
      </div>
    </main>
  );
}
*/
